import { displayTextLabelValidator, getDisplayTextLabelValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { defaultDatePickerDateFormat, defaultDatePickerTodayDateFormat } from '../../../subcomponents/date-picker/types/props';
import { defaultShowtimePickerDisplayText, defaultShowtimePickerDisplayTextValidatorSchema } from '../../../subcomponents/showtime-picker/types/display-text';
import { DateShowtimePickerInternalAction } from './internal-action';
/**
 * Default display text for the Showtime Picker component.
 */
export const defaultDateShowtimePickerDisplayText = Object.assign(Object.assign({}, defaultShowtimePickerDisplayText), { actionButtonLabel: 'Add cinemas', nextShowtimeForSiteOnDateMessage: [
        'This movie is not available on this date. Next screening is on the ',
        {
            text: '${nextScreeningDate|d|Do of MMMM}',
            internalAction: DateShowtimePickerInternalAction.NavigateToDate
        },
        '.'
    ], lastShowtimeForSiteOnDateMessage: [
        'This movie is not available on this date. Last screening is on the ',
        {
            text: '${lastScreeningDate|d|Do of MMMM}',
            internalAction: DateShowtimePickerInternalAction.NavigateToDate
        },
        '.'
    ], allFilmsToggleLabel: 'Show all films', datePickerDateFormat: defaultDatePickerDateFormat, datePickerTodayDateFormat: defaultDatePickerTodayDateFormat });
export const dateShowtimePickerDisplayTextValidator = Validator.object(Object.assign(Object.assign({}, defaultShowtimePickerDisplayTextValidatorSchema), { nextShowtimeForSiteOnDateMessage: getDisplayTextLabelValidator(Object.values(DateShowtimePickerInternalAction)), lastShowtimeForSiteOnDateMessage: getDisplayTextLabelValidator(Object.values(DateShowtimePickerInternalAction)), allFilmsToggleLabel: Validator.nonEmptyString, datePickerDateFormat: displayTextLabelValidator, datePickerTodayDateFormat: displayTextLabelValidator }));
//# sourceMappingURL=display-text.js.map